import React from "react";
import { ArrowRight } from "lucide-react";

export default function ResearchCTA() {
  return (
    <section className="mt-16 border-t border-[#2a2620]" data-testid="research-article-cta">
      <div className="max-w-4xl mx-auto px-6 sm:px-8 py-16 text-center">
        <p className="font-mono-eav text-[11px] tracking-[0.24em] uppercase text-[#b8963e]">
          The AI Visibility Score™
        </p>
        <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl text-[#f4efe6] leading-tight">
          What does AI say about your business?
        </h2>
        <p className="mt-4 text-base sm:text-lg text-[#c9bca4]">
          Get your AI Visibility Score™. <span className="text-[#f4efe6]">Instant. Your score. No pitch.</span>
        </p>
        <a href="https://theentityagency.com"
           data-testid="research-cta-button"
           className="mt-8 inline-flex items-center gap-2 btn-gold">
          Request a Free Snapshot <ArrowRight className="w-4 h-4" />
        </a>
      </div>
    </section>
  );
}
